import React, { FC, ReactElement } from 'react'
import styles from './CreateWalletSuccess.module.css'

import CreateWalletHeader from '../create-wallet-header'
import CreateWalletFooter from '../create-wallet-footer'
import CreateWalletTitle from '../create-wallet-title'
import TweetIntentButton from '@/components/tweet-intent-button'
import Event from '@/utils/event'

import { useRouter } from 'next/navigation'
import { useSignIn } from '@/utils/hooks/useLoggedIn'

const CreateWalletSuccess: FC<{
	step: number
	totalSteps: number
	onBack: (evt: any) => void
}> = ({ step, totalSteps, onBack }): ReactElement => {
	const router = useRouter()
	const signIn = useSignIn()
	const handleSubmit = React.useCallback(() => {
		signIn()
	  	const isInStandaloneMode = ('standalone' in window?.navigator) && (window?.navigator?.standalone)
		if (isInStandaloneMode && typeof Notification !== 'undefined') {
			if (Notification.permission !== 'granted') {
				Event.emit('open-get-notifications-modal')
			}
		}
		router.push('/wallet')
	}, [router, signIn])

	return (
		<>
			<CreateWalletHeader
				step={step}
				total={totalSteps}
				nextDisabled={false}
				onNext={handleSubmit}
				onBack={onBack}
			/>
			<div className={styles.root}>
				<img src="/success.svg" alt="" className={styles.icon} />
				<CreateWalletTitle step={step} />
				<TweetIntentButton
					className={styles.buttonWrapper}
					buttonClassName={styles.button}
					title="Share to twitter"
					intent={`gm i just created an @ordinalswallet on https://ordinalswallet.com!\n\nyou don’t want to miss this`}
				/>
			</div>
			<CreateWalletFooter step={step} nextDisabled={false} onNext={handleSubmit} onBack={onBack} />
		</>
	)
}

export default CreateWalletSuccess
